<template>
  <div>
    <div class="container-fluid px-3">
      <!-- Header -->
      <div class="row">
        <div
          class="col-12 mt-3 mb-3 d-flex align-items-center position-relative bg-main card w-100"
        >
          <h5 class="mb-0 fw-bold text-white text-center w-100 card-header">
            GESTIÓN DE ALMACENES
          </h5>

          <button
            type="button"
            class="btn btn-sm position-absolute end-0 me-3 btn btn-sm btn-light pt-1 fw-bold"
            @click="changePage('home')"
          >
            <i class="fas fa-home me-1"></i> Atrás
          </button>
        </div>
      </div>

      <!-- Filtro de sede -->
      <div class="row mb-3">
        <div class="col-md-4">
          <div class="input-group input-group-sm">
            <span class="input-group-text bg-main text-white"
              ><i class="fas fa-map-marker-alt"></i
            ></span>
            <select
              class="form-control"
              v-model="filter.campus_id"
              @change="mtdGetData()"
            >
              <option :value="null" disabled>Seleccione sede</option>
              <option
                v-for="(item, index) in dataCampus"
                :key="index"
                :value="item.id"
              >
                {{ item.name }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <!-- Layout dividido -->
      <div class="row g-3">
        <!-- ==================== COLUMNA IZQUIERDA: ALMACENES GENERALES ==================== -->
        <div class="col-md-6">
          <div class="card border-0 shadow-sm h-100">
            <div
              class="card-header text-dark d-flex justify-content-between align-items-center py-2"
            >
              <span class="fw-bold"
                ><i class="fas fa-boxes me-2"></i>ALMACENES GENERALES</span
              >
              <button
                class="btn btn-sm btn-light text-main fw-bold"
                style="background-color: #d3d4d5;"
                @click="mtdModalShow(0, null, 'almacen')"
              >
                <i class="fas fa-plus me-1"></i> Nuevo
              </button>
            </div>
            <div class="card-body p-2">
              <!-- Buscador izquierdo -->
              <div class="input-group input-group-sm mb-2">
                <span class="input-group-text bg-main text-white"
                  ><i class="fas fa-search"></i
                ></span>
                <input
                  v-model="searchLeft"
                  @keyup="calcLeft()"
                  type="text"
                  class="form-control"
                  placeholder="Buscar almacén..."
                />
              </div>

              <!-- Tabla izquierda -->
              <table class="table table-bordered table-sm border-main mb-1">
                <caption class="py-0 my-0"></caption>
                <thead class="bg-main">
                  <tr class="text-white text-center small">
                    <th style="width: 40px">N°</th>
                    <th style="width: 70px">CÓDIGO</th>
                    <th>NOMBRE</th>
                    <th style="width: 70px">ESTADO</th>
                    <th style="width: 80px">ACCIONES</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="dataShowLeft.length === 0">
                    <td colspan="5" class="text-center text-muted small py-3">
                      No hay registros
                    </td>
                  </tr>
                  <tr
                    v-for="(item, index) in dataShowLeft"
                    :key="index"
                    class="text-center small align-middle"
                  >
                    <td>{{ (selectPageLeft - 1) * 7 + index + 1 }}</td>
                    <td class="fw-bold text-main">{{ item.code || "—" }}</td>
                    <td class="text-start">{{ item.name }}</td>
                    <td>
                      <span
                        :class="
                          item.state == 1
                            ? 'badge bg-success'
                            : 'badge bg-secondary'
                        "
                      >
                        {{ item.state == 1 ? "Activo" : "Inactivo" }}
                      </span>
                    </td>
                    <td>
                      <div class="d-flex justify-content-center gap-1">
                        <button
                          class="btn btn-sm a-success text-white py-0 px-1"
                          @click="mtdModalShow(1, item, 'almacen')"
                          title="Editar"
                        >
                          <i class="fa fa-edit"></i>
                        </button>
                        <button
                          class="btn btn-sm a-danger text-white py-0 px-1"
                          @click="Datadetail(item.id, 2, 'almacen')"
                          title="Eliminar"
                        >
                          <i class="fas fa-trash-alt"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <!-- Paginado izquierdo -->
              <div
                v-if="stepPaginationLeft.length > 1"
                class="d-flex justify-content-center"
              >
                <nav>
                  <ul class="pagination pagination-sm mb-0">
                    <li
                      class="page-item"
                      :class="{ disabled: selectPageLeft === 1 }"
                    >
                      <a
                        class="page-link"
                        href="javascript:void(0)"
                        @click="selectPageLeft > 1 && selectPageLeft--"
                        >‹</a
                      >
                    </li>
                    <li
                      v-for="p in stepPaginationLeft"
                      :key="p"
                      class="page-item"
                      :class="{ active: selectPageLeft === p }"
                    >
                      <a
                        class="page-link"
                        href="javascript:void(0)"
                        @click="selectPageLeft = p"
                        >{{ p }}</a
                      >
                    </li>
                    <li
                      class="page-item"
                      :class="{
                        disabled: selectPageLeft === stepPaginationLeft.length,
                      }"
                    >
                      <a
                        class="page-link"
                        href="javascript:void(0)"
                        @click="
                          selectPageLeft < stepPaginationLeft.length &&
                            selectPageLeft++
                        "
                        >›</a
                      >
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>

        <!-- ==================== COLUMNA DERECHA: Áreas con collapse ==================== -->
        <div class="col-md-6">
          <div class="card border-0 shadow-sm h-100">
            <div
              class="card-header text-dark d-flex justify-content-between align-items-center py-2"
            >
              <span class="fw-bold"
                ><i class="fas fa-layer-group me-2"></i>ÁREAS Y
                SUB-ALMACENES</span
              >
            </div>
            <div class="card-body p-2">
              <!-- Buscador derecho -->
              <div class="input-group input-group-sm mb-2">
                <span class="input-group-text bg-main text-white"
                  ><i class="fas fa-search"></i
                ></span>
                <input
                  v-model="searchRight"
                  type="text"
                  class="form-control"
                  placeholder="Buscar área o sub-almacén..."
                />
              </div>

              <!-- Sin datos -->
              <div
                v-if="filteredAreas.length === 0"
                class="text-center text-muted small py-3"
              >
                No hay áreas registradas
              </div>

              <!-- Accordion de áreas -->
              <div class="accordion accordion-flush" id="accordionAreas">
                <div
                  v-for="(areaGroup, areaIndex) in filteredAreas"
                  :key="areaIndex"
                  class="accordion-item border mb-2 rounded"
                >
                  <h2 class="accordion-header d-flex align-items-center">
                    <button
                      class="accordion-button collapsed py-2 px-3 small fw-bold rounded flex-grow-1"
                      type="button"
                      @click="toggleArea(areaGroup.area)"
                      :class="{
                        'bg-main-light': openAreas.includes(areaGroup.area),
                      }"
                    >
                      <i class="fas fa-folder me-2 text-main"></i>
                      {{ areaGroup.area }}
                      <span class="badge bg-main ms-2">{{
                        areaGroup.items.length
                      }}</span>
                      <i
                        class="fas ms-auto"
                        :class="
                          openAreas.includes(areaGroup.area)
                            ? 'fa-chevron-up'
                            : 'fa-chevron-down'
                        "
                      >
                      </i>
                    </button>
                    <!-- Botón + para agregar sub-almacén en esta área -->
                    <button
                      class="btn btn-sm btn-bm-noradius ms-1 me-1 py-0 px-2 flex-shrink-0"
                      title="Agregar sub-almacén en esta área"
                      @click.stop="
                        mtdModalShow(0, null, 'area', areaGroup.area)
                      "
                    >
                      <i class="fas fa-plus"></i>
                    </button>
                  </h2>

                  <!-- Items del área -->
                  <div
                    v-if="openAreas.includes(areaGroup.area)"
                    class="px-2 pb-2"
                  >
                    <table
                      class="table table-sm table-bordered border-main mb-0 mt-1"
                    >
                      <caption class="py-0 my-0"></caption>
                      <thead class="table-light">
                        <tr class="text-center small text-main">
                          <th style="width: 30px">N°</th>
                          <th>NOMBRE</th>
                          <th style="width: 70px">ESTADO</th>
                          <th style="width: 80px">ACCIONES</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(subItem, subIndex) in areaGroup.items"
                          :key="subIndex"
                          class="text-center small align-middle"
                        >
                          <td>{{ subIndex + 1 }}</td>
                          <td class="text-start">{{ subItem.name }}</td>
                          <td>
                            <span
                              :class="
                                subItem.state == 1
                                  ? 'badge bg-success'
                                  : 'badge bg-secondary'
                              "
                            >
                              {{ subItem.state == 1 ? "Activo" : "Inactivo" }}
                            </span>
                          </td>
                          <td>
                            <div class="d-flex justify-content-center gap-1">
                              <button
                                class="btn btn-sm a-success text-white py-0 px-1"
                                @click="mtdModalShow(1, subItem, 'area')"
                                title="Editar"
                              >
                                <i class="fa fa-edit"></i>
                              </button>
                              <button
                                class="btn btn-sm a-danger text-white py-0 px-1"
                                @click="Datadetail(subItem.id, 2, 'area')"
                                title="Eliminar"
                              >
                                <i class="fas fa-trash-alt"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- Acciones del área (editar área en sí) -->
                  <div
                    class="d-flex justify-content-end px-2 pb-1"
                    v-if="!openAreas.includes(areaGroup.area)"
                  >
                    <small class="text-muted fst-italic"
                      >{{ areaGroup.items.length }} sub-almacén(es)</small
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Almacén Principal -->
    <cModalAlmacenPrincipalVue
      :title="modalAlmacen.title"
      :boo_modal="modalAlmacen.show"
      :num="modalAlmacen.num"
      :payload="modalAlmacen.payload"
      @closeModal="closeModalAlmacen"
      @Datadetail="onDatadetailAlmacen"
    />

    <!-- Modal Sub-Almacén / Área -->
    <cModalSubAlmacenVue
      :title="modalArea.title"
      :boo_modal="modalArea.show"
      :num="modalArea.num"
      :payload="modalArea.payload"
      @closeModal="closeModalArea"
      @Datadetail="onDatadetailArea"
    />

    <SweetAlert :swal="swal" ref="SweetAlert" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import SweetAlert from "@/components/shared/SweetAlert/SweetAlert.vue";
import cModalAlmacenPrincipalVue from "../../modals/Mantenimiento/cModalAlmacenes.vue";
import cModalSubAlmacenVue from "../../modals/Mantenimiento/cModalSubAlmacenes.vue";

export default {
  name: "c-mantenedores-pages-almacen",
  components: { SweetAlert, cModalAlmacenPrincipalVue, cModalSubAlmacenVue },
  data() {
    return {
      swal: null,

      // Datos crudos del backend
      dataAlmacenes: [],
      dataCampus: [],

      filter: {
        campus_id: null,
      },

      // ---- LADO IZQUIERDO: almacenes principales (almacen_id == "1") ----
      searchLeft: "",
      dataShowLeft: [],
      selectPageLeft: 1,
      stepPaginationLeft: [],

      // ---- LADO DERECHO: áreas con sub-almacenes ----
      searchRight: "",
      openAreas: [], // array de nombres de área abiertos

      // Modal almacén principal
      modalAlmacen: {
        show: false,
        num: 0,
        title: "",
        payload: null,
      },

      // Modal área / sub-almacén
      modalArea: {
        show: false,
        num: 0,
        title: "",
        payload: null,
      },
    };
  },
  watch: {
    selectPageLeft() {
      this.calcLeft();
    },
  },
  computed: {
    // Almacenes principales: almacen_id === "1" (dependen directamente del almacén general)
    almacenesPrincipales() {
      return this.dataAlmacenes.filter(
        (a) => a.almacen_id === "1" || a.almacen_id === 1
      );
    },

    // Sub-almacenes: tienen area definida
    subAlmacenes() {
      return this.dataAlmacenes.filter((a) => a.area && a.area !== null);
    },

    // Agrupar sub-almacenes por área, aplicando búsqueda
    filteredAreas() {
      const query = this.searchRight.toUpperCase().trim();
      const items = query
        ? this.subAlmacenes.filter(
            (a) =>
              a.name.toUpperCase().includes(query) ||
              a.area.toUpperCase().includes(query)
          )
        : this.subAlmacenes;

      // Agrupar por área
      const grouped = {};
      items.forEach((item) => {
        if (!grouped[item.area]) grouped[item.area] = [];
        grouped[item.area].push(item);
      });

      return Object.keys(grouped).map((area) => ({
        area,
        items: grouped[area],
      }));
    },
  },
  created() {
    this.mtdGetCampus();
  },
  methods: {
    ...mapActions(["get", "post"]),

    // ===================== DATOS =====================
    mtdGetData() {
      this.post({
        url: this.$store.getters.get__url + "/Almacen/filter",
        token: this.$store.getters.get__token,
        params: this.filter,
      })
        .then((response) => {
          this.dataAlmacenes = response.data;
          this.calcLeft();
        })
        .catch((errors) => {
          this.$refs.SweetAlert.showError(errors);
        });
    },

    mtdGetCampus() {
      this.get({
        url: this.$store.getters.get__url + "/OperationsRoom",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.dataCampus = response.data;
          this.filter.campus_id = this.dataCampus[0].id;
          this.mtdGetData();
        })
        .catch((errors) => {
          this.$refs.SweetAlert.showError(errors);
        });
    },

    // ===================== PAGINADO IZQUIERDO =====================
    calcLeft() {
      const items = 7;
      let data = this.almacenesPrincipales;
      if (this.searchLeft.length >= 2) {
        const q = this.searchLeft.toUpperCase();
        data = data.filter((e) => e.name.toUpperCase().includes(q));
      }
      const totalPages = Math.ceil(data.length / items);
      this.stepPaginationLeft = Array.from(
        { length: totalPages },
        (_, i) => i + 1
      );
      if (this.selectPageLeft > totalPages) this.selectPageLeft = 1;
      const start = (this.selectPageLeft - 1) * items;
      this.dataShowLeft = data.slice(start, start + items);
    },

    // ===================== COLLAPSE ÁREAS =====================
    toggleArea(area) {
      const idx = this.openAreas.indexOf(area);
      if (idx === -1) {
        this.openAreas.push(area);
      } else {
        this.openAreas.splice(idx, 1);
      }
    },

    // ===================== MODALES =====================
    mtdModalShow(num, payload, tipo, areaPreset = null) {
      if (tipo === "almacen") {
        this.modalAlmacen.num = num;
        this.modalAlmacen.title =
          num === 0 ? "Registrar Almacén" : "Editar Almacén";
        this.modalAlmacen.payload = num === 0 ? null : { ...payload };
        this.modalAlmacen.show = true;
      } else {
        this.modalArea.num = num;
        this.modalArea.title =
          num === 0 ? "Registrar Sub-Almacén" : "Editar Sub-Almacén";
        this.modalArea.payload =
          num === 0
            ? {
                name: "",
                area: areaPreset || "",
                state: 1,
                almacen_id: "2,3,4",
              }
            : { ...payload };
        this.modalArea.show = true;
      }
    },

    closeModalAlmacen() {
      this.modalAlmacen.show = false;
      this.modalAlmacen.payload = null;
    },

    closeModalArea() {
      this.modalArea.show = false;
      this.modalArea.payload = null;
    },

    // Recibe data del modal de almacén principal y llama al CRUD
    // Envía al back: campu_id, code, name, state, almacen_id = 1
    onDatadetailAlmacen(data, num) {
      const payload = {
        action: num === 0 ? "c" : "u",
        campu_id: this.filter.campus_id,
        almacen_id: 1,
        code: data.code,
        name: data.name,
        state: data.state ?? 1,
      };
      if (num === 1) payload.id = data.id;
      this.addDatadetail(payload, num, "almacen");
    },

    // Recibe data del modal de sub-almacén/área y llama al CRUD
    // Envía al back: campu_id, name, state, area
    onDatadetailArea(data, num) {
      const payload = {
        action: num === 0 ? "c" : "u",
        campu_id: this.filter.campus_id,
        name: data.name,
        state: data.state ?? 1,
        area: data.area,
      };
      if (num === 1) payload.id = data.id;
      this.addDatadetail(payload, num, "area");
    },

    // ===================== CRUD =====================
    Datadetail(id, num_detail, tipo) {
      // num_detail 2 = eliminar
      this.$refs.SweetAlert.showConfirmSimple2(
        "",
        "¿Estás seguro?",
        "warning",
        "Eliminar"
      ).then((result) => {
        if (result.value) {
          this.addDatadetail({ action: "d", id }, 2, tipo);
        }
      });
    },

    addDatadetail(payload_detail, num_detail, tipo) {
      this.post({
        url: this.$store.getters.get__url + "/Almacen/crudAlmacen",
        token: this.$store.getters.get__token,
        params: payload_detail,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            if (num_detail === 2) {
              this.$refs.SweetAlert.showSuccess("Registro eliminado");
            } else {
              this.$refs.SweetAlert.showSuccess(
                num_detail === 0 ? "Registro exitoso" : "Modificación exitosa"
              );
              if (tipo === "almacen") this.closeModalAlmacen();
              else this.closeModalArea();
            }
            this.mtdGetData();
          }
        })
        .catch((error) => {
          this.$refs.SweetAlert.showError(error);
        });
    },

    changePage(page) {
      this.$emit("changePage", page);
    },
  },
};
</script>

<style scoped>
.bg-main-light {
  background-color: rgba(var(--bs-primary-rgb), 0.08);
}

.accordion-button::after {
  display: none; /* ocultamos el arrow nativo de Bootstrap */
}

.accordion-button {
  background: #f8f9fa;
  border-radius: 6px !important;
}

.accordion-button:not(.collapsed) {
  box-shadow: none;
}

.accordion-item {
  border-radius: 6px;
  overflow: hidden;
}
</style>